import OverviewSVG from '../../assets/svg/overview.svg';
export default OverviewSVG;
